import { Reveal } from "./Reveal";

const phases = [
  {
    n: "01",
    title: "Valutazione iniziale",
    text: "Prima visita con TAC 3D o Panoramica 2D inclusa (diagnosi da decidere con il professionista e se necessaria). L'odontoiatra e il chirurgo valutano l'osso e definiscono il piano di cura personalizzato, con preventivo scritto e definitivo.",
    span: "lg:col-span-2",
    img: "https://static.prod-images.emergentagent.com/jobs/c24763e7-4110-455f-bc22-09e351652797/images/310649150f7b8588bf0b57182b0d4c035c21bcda87baaca641d756047881d151.jpeg",
    imgAlt: "Dentista che parla con la paziente seduta sulla poltrona durante la valutazione iniziale",
    imgClass: "h-64 object-top",
  },
  {
    n: "02",
    title: "Impianti a carico immediato",
    text: "Inserimento degli impianti in un'unica seduta, con eventuali estrazioni comprese. Tecniche mini-invasive e sedazione cosciente su richiesta, per un intervento più sereno.",
    span: "",
    img: "https://static.prod-images.emergentagent.com/jobs/c24763e7-4110-455f-bc22-09e351652797/images/948eabf55c78f1f9d15d42bbb615c7304157a9ac32c67da7c0b506c6966d1ed4.jpeg",
  },
  {
    n: "03",
    title: "Protesi fissa in giornata",
    text: "Denti fissi provvisori avvitati in circa 6 ore, se le condizioni cliniche lo consentono: avrai il provvisorio fisso in giornata. Dopo la guarigione (3–6 mesi), la protesi definitiva. Tornerai subito a mangiare e sorridere.",
    span: "lg:col-span-3",
  },
];

export const HowItWorks = () => (
  <section id="come-funziona" className="py-24 md:py-32 px-6 md:px-12" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto">
      <Reveal>
        <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#7D9285] mb-4">Il percorso</p>
        <h2 className="font-serif-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#15201A] max-w-3xl">
          Come funziona l'implantologia a <em className="italic text-[#385244]">carico immediato</em>
        </h2>
      </Reveal>
      <div className="mt-16 grid lg:grid-cols-3 gap-6">
        {phases.map((p, i) => (
          <Reveal key={p.n} delay={i * 0.12} className={p.span}>
            <div
              className={`relative h-full bg-white border border-border rounded-[32px] p-8 md:p-10 overflow-visible ${p.img ? "flex flex-col" : ""}`}
              data-testid={`phase-card-${p.n}`}
            >
              <span className="font-serif-display font-light text-7xl md:text-8xl text-[#385244]/15 absolute -top-8 -left-2 select-none pointer-events-none">
                {p.n}
              </span>
              <div className="relative mt-8">
                <h3 className="font-serif-display text-2xl md:text-3xl text-[#15201A]">{p.title}</h3>
                <p className="mt-4 text-base md:text-lg leading-relaxed text-[#5C6B61]">{p.text}</p>
              </div>
              {p.img && (
                <img
                  src={p.img}
                  alt={p.imgAlt || "Protesi All on Four su impianti"}
                  loading="lazy"
                  decoding="async"
                  className={`mt-6 rounded-2xl w-full object-cover ${p.imgClass || "h-40"}`}
                />
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
